import { NOTIFICATION_TYPE } from '@/types/notifications'

export enum TOAST_POSITION {
  TOP_RIGHT = 'top-right',
  TOP_LEFT = 'top-left',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
}

export type IToastOptions = {
  title?: string
  type?: NOTIFICATION_TYPE
  timeout?: number | 'none'
}

export interface IToast extends IToastOptions {
  id: string
  message: string
  type: NOTIFICATION_TYPE
}
